import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GameState, IJsonWinnerSet, IGamePrizeWinner, IGameStateChangedArgs, IGameWonArgs } from '@/components/game/_domain/models';
import { PrizeHelper } from '@/components/game/_domain/helpers/prize-helper';
import { IPrizeElement, IPrizeStructure, IPrizeTicketBook } from '@/components/game/implementations/_default/_domain/models';
import { IGameController } from '@/components/game/_domain/models/game-controller';

import TombolaBaseComponent from '@/components/base/base.component';
@Component({
  name: 'BritainsBiggestBingoWinnerListComponent'
})
export default class BritainsBiggestBingoWinnerListComponent extends TombolaBaseComponent{
  @Prop() public gameController: IGameController;
  protected gameWinnerInfo: IJsonWinnerSet[] = [];
  protected isVisible: boolean = false;
  public prizeHelper: PrizeHelper = new PrizeHelper();

  private mounted() {
    const game = this.gameController.getGame();
    this.updateWinnerListVisibility(game.state);

    Vue.nextTick(() => {
      this.gameController
          .onGameStateChanged(this.handleGameStateChanged)
          .onGameWon(this.handleGameWon);
    });
  }

  protected handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    const gameState = eventArgs.currentGameState;
    this.updateWinnerListVisibility(gameState);
  }

  protected handleGameWon(eventArgs: IGameWonArgs) {
    this.gameWinnerInfo = eventArgs.jsonGameWinnerInfo;
  }

  protected updateWinnerListVisibility(gameState: GameState) {
    this.isVisible = gameState === GameState.WinnersDisplayed;
  }

  private formatWinnerMessage(username: string, prizeInPence: number): string {
    return `${username} (${this.prizeHelper.formatPrize(prizeInPence)})`;
  }

  private getStagePrizeTotal(winners: IGamePrizeWinner[]): string {
    let total: number = 0;
    winners.map((winner) => {
      total += winner.prizeInPence;
    });
    return this.prizeHelper.formatPrize(total);
  }

  protected formatPrizeMessage(winnerSet: IJsonWinnerSet): string {
    return `${winnerSet.prizeName}: ${this.getStagePrizeTotal(winnerSet.winners)}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/britains-biggest-bingo/_components/winner-list/winner-list.component.ts